var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.packageItem)?_c('ModalEdit',{ref:"modalEdit",attrs:{"edited-package-item":_vm.packageItem,"product":_vm.product,"updating":_vm.updating},on:{"submit":_vm.doUpdatePackageItem}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }